import { atom } from "recoil";

export const storeSingleDataAtom = atom({
  key: "store-single-data",
  default: { status: "initial", data: [] },
});
